
<q-popup-edit
  ref="popupEdit"
  class="cmp-domain-popup"
  content-class="domain-popup"
  anchor="top middle"
  self="bottom middle"
  v-bind="$attrs"
  :cover="false"
  v-on="$listeners"
>
  <slot></slot>
</q-popup-edit>
